import {ButtonProps as MuiButtonProps} from '@mui/material';
import MuiButton from '@mui/material/Button';
import {styled} from '@mui/material/styles';

export type ButtonProps = MuiButtonProps & {
  shape?: 'rounded' | 'default' | 'rectangle';
  loading?: boolean;
  isInstallmentType?: boolean;
  component?: string;
};

export const ButtonStyled = styled(MuiButton)<ButtonProps>(({shape}) => {
  if (shape === 'rounded') {
    return {
      boxShadow: 'none',
      borderRadius: '4rem'
    };
  }
  return {
    boxShadow: 'none'
  };
});
